import { Injectable, InjectionToken } from '@angular/core';

export const ImgHostServiceToken = new InjectionToken<IImgSvcHostService>('IImgSvcHostService');

interface iVerifyImageMatch {
  action: string;
  match: number;
}
export interface IImgSvcHostService {
  sendPartyData(partyData: Object): void;
  verifyImageMatch(action: iVerifyImageMatch): void;
}

@Injectable()
abstract class HostService implements IImgSvcHostService {
  constructor() {
  }
  public abstract sendPartyData(partyData: Object): void;
  public abstract verifyImageMatch(action: iVerifyImageMatch): void;
}

@Injectable()
export class ExternalHostedImgHostService extends HostService {

  public sendPartyData(partyData: Object): void {
    window.frs_host.sendPartyData(JSON.stringify(partyData));
    window.close();
  }
  public verifyImageMatch(imageMatch: iVerifyImageMatch): void {
    window.frs_host.verifyImageMatch(JSON.stringify(imageMatch));
    window.close();
  }
}

@Injectable()
export class BrowserHostedImgHostService extends HostService {
  public sendPartyData(partyData: Object): void {
    console.log(`sendPartyData: ` + JSON.stringify(partyData));
  }
  public verifyImageMatch(verifyImageMatch: iVerifyImageMatch): void {
    console.log(`verifyImageMatch: ` + verifyImageMatch.action, verifyImageMatch.match);
  }
}